//@ts-nocheck
import { Transforms, Editor, Element } from 'slate'
import { JsonNode } from '../../../utils/types'
import { getSelectedCellsInATable } from '../table/utils/getSelectedCellsInATable'

const formAttributes = (oldAttributes: { style: {} }, alignment: string) => {
    let redactorAttributes: Partial<INodeAttrs> = {}

    if (oldAttributes) {
        redactorAttributes = {
            ...redactorAttributes,
            ...oldAttributes["redactor-attributes"]
        }
    }

    const elementAttribute = {
        attrs: {
            ...oldAttributes,
            style: {
                ...oldAttributes?.style,
                "text-align": alignment
            },
            "redactor-attributes": redactorAttributes
        }
    }

    return elementAttribute;
}
export const alignNode = (editor, alignment) => {
    Editor.normalize(editor, { force: true })
    const { selection } = editor;
    if (selection === null) {
        return
    }

    const [table] = Editor.nodes(editor, {
        match: (n: ElementWithType) => {
            return n.type === 'table'
        },
        mode: 'lowest'
    })

    const cells = table && Array.from(getSelectedCellsInATable(editor, table[1]))
    if (cells) {
        cells.forEach(([cell, cellPath]) => {
            const elementAttribute = formAttributes(cell.attrs, alignment)
            Transforms.setNodes(editor, elementAttribute as ElementWithType, { at: cells.length === 1 ? selection : cellPath })
        });
    } else {
        for (const [n, p] of Editor.nodes(editor, { at: selection })) {
            const node: JsonNode = n
            const path = p
            if (Element.isElement(node) && node.type !== 'docs' && node.type !== 'table') {
                const oldAttributes: any = node.attrs

                let redactorAttributes: any = {}

                if (oldAttributes) {
                    redactorAttributes = {
                        ...redactorAttributes,
                        ...oldAttributes['redactor-attributes']
                    }
                }
                if (node.type === 'img') {
                    redactorAttributes.position = alignment
                }

                const elementAttribute = {
                    attrs: {
                        ...oldAttributes,
                        style: {
                            ...oldAttributes?.style,
                            "text-align": alignment
                        },
                        "redactor-attributes": redactorAttributes
                    }
                }
                const [liNode] = Editor.nodes(editor, {
                    match: (n) => n.type === 'li',
                    at: selection,
                    mode: 'lowest'
                })
                if (liNode) Transforms.setNodes(editor, elementAttribute, { at: liNode[1] })
                else Transforms.setNodes(editor, elementAttribute, { at: selection })
            }
            // in case if normalizing is called, editor selection changes and hence this change
            if (editor.selection) Transforms.select(editor, editor.selection)
        }
    }

}


export const isNodeAligned = (editor, style) => {
    const selection = editor.selection;

    if (selection === null) {
        return false
    }

    const [node] = Editor.nodes(editor, { match: (n: any) => n?.attrs?.style?.["text-align"] })
    //@ts-ignore
    if (node) return node[0].attrs.style["text-align"] === style
    else return style === 'left'
}
